import React, { useEffect, useState } from 'react';
import {
  AutocompleteComponent,
  CheckboxesComponent,
  DialogComponent,
  Spinner,
} from '../../../../../../Components';
import { showError, showSuccess } from '../../../../../../Helper';
import {
  BulkLeadsAutoRotationAsync,
  GetAllSharedRotationScheme,
} from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { useDebouncedAction } from '../../../../../../Hooks/DebouncedAction';
import { claimTypeEnums } from '../../../Utilities/Utilities';

export default function SendToRotationDialog({
  onClose,
  open,
  leadData,
  selectedIds,
  reload,
  setLoading,
}) {
  const [isLoading, setIsLoading] = useState({
    loading: false,
    updating: false,
  });
  const [allSchemas, setAllSchemas] = useState([]);
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSendToAllChecked, setIsSendToAllChecked] = useState(false);
  const [selectedSchemesIdes, setSelectedSchemesIdes] = useState([]);

  const getAllSharedRotationScheme = useDebouncedAction(async (search) => {
    setIsLoading({ loading: true, updating: false });
    try {
      const res = await GetAllSharedRotationScheme({
        search: search,
        isForOwnerLeads: false,
      });
      setAllSchemas(res);
    } catch {
      showError('something went wrong');
    } finally {
      setIsLoading({ loading: false, updating: false });
    }
  });

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsLoading({ loading: false, updating: true });
    const body = {
      sharedLeadIds: selectedIds ? selectedIds : [leadData?.sharedLeadId],
      recommendedSchemesIds: selectedSchemesIdes,
      claimType: claimTypeEnums.SendToRotationClaim,
    };
    try {
      await BulkLeadsAutoRotationAsync(body);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        onClose();
        reload();
        showSuccess('send to rotation successfully');
      }, 4000);
    } catch {
      showError('something went wrong');
    } finally {
      setIsLoading({ loading: false, updating: false });
    }
  };

  useEffect(() => {
    getAllSharedRotationScheme();
  }, []);
  return (
    <DialogComponent
      titleText={'Send To Rotation'}
      saveText={'confirm'}
      saveType='button'
      maxWidth='sm'
      saveClasses='btns theme-solid w-100 mx-2 mb-2'
      isOpen={open}
      onSaveClicked={onSubmit}
      onCancelClicked={onClose}
      dialogContent={
        <>
          <div className='d-flex-column-center'>
            <Spinner
              isAbsolute
              isActive={isLoading.updating}
            />
            <AutocompleteComponent
              idRef='recommendedSchemesRef'
              labelValue='Recommended Schemes'
              data={allSchemas}
              selectedValues={selectedSchemes}
              multiple
              disableClearable={false}
              displayLabel={(option) => option?.label || ''}
              chipsLabel={(option) => option?.label || ''}
              isLoading={isLoading.loading}
              withLoader
              withoutSearchButton
              isDisabled={isDisabled}
              onInputKeyUp={(event) => {
                const { value } = event.target;
                getAllSharedRotationScheme(value);
              }}
              onChange={(e, newValues) => {
                setSelectedSchemesIdes(
                  newValues.map((e) => e.rotationSchemeId)
                );
                setSelectedSchemes(newValues);
              }}
            />
          </div>
          <CheckboxesComponent
            checked={isSendToAllChecked}
            label='Send to All Schemas'
            wrapperClasses='mt-3'
            onSelectedCheckboxChanged={() => {
              setIsSendToAllChecked(!isSendToAllChecked);
              if (!isSendToAllChecked) {
                setIsDisabled(true);
                setSelectedSchemes([]);
                setSelectedSchemesIdes([]);
              } else setIsDisabled(false);
            }}
          />
        </>
      }
    />
  );
}
